import { render, staticRenderFns } from "./nacionalAdd.vue?vue&type=template&id=72dba7de"
import script from "./nacionalAdd.vue?vue&type=script&lang=js"
export * from "./nacionalAdd.vue?vue&type=script&lang=js"
import style0 from "./nacionalAdd.vue?vue&type=style&index=0&id=72dba7de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports